import { Trans, useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@repo/mui-config/color-palette';
import { convertNumberToLocaleMoneyFormat } from '@repo/shared/helpers';

import { titleProps } from '../common/helpers/title-props';

export function LiberisAgreementsFormTitle({
  isMultiprovider,
  amount,
}: {
  isMultiprovider?: boolean;
  amount?: number;
}) {
  const { t } = useTranslation();

  if (isMultiprovider) {
    return (
      <>
        <Typography {...titleProps}>
          <Trans
            components={[<span style={{ color: colorPalette.primary.main }} />]}
            i18nKey="welcomePage.loanApplicationPossible.liberis.agreementsForm.multiprovider.title"
            values={{
              amount: convertNumberToLocaleMoneyFormat(amount || 0),
            }}
          />
        </Typography>
      </>
    );
  }

  return (
    <>
      <Typography {...titleProps}>
        {t('welcomePage.loanApplicationPossible.liberis.agreementsForm.title.seeFullOffer')}{' '}
        <Typography component="span" color={colorPalette.primary.main} {...titleProps}>
          {t('welcomePage.loanApplicationPossible.liberis.agreementsForm.title.loans')}
        </Typography>
      </Typography>
    </>
  );
}
